import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Fade from "@mui/material/Fade";
import { useNavigate } from "react-router-dom";
import { ClickAwayListener } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
export default function AccountMenu() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const navigate = useNavigate();
  const open = Boolean(anchorEl);
  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (route) => {
    handleClose();
    navigate(route);
  };

  return (
    <div>
      <ClickAwayListener onClickAway={handleClose}>
        <Button
          sx={{ my: 2, color: "white", display: "flex" }}
          onClick={handleOpen}
          endIcon={<ExpandMoreIcon />}
        >
          Konton
        </Button>
      </ClickAwayListener>
      <Menu
        id="fade-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
        sx={{ mt: 2 }}
      >
        <MenuItem onClick={() => handleClick("/clientsarticles")}>
          Klientartiklar
        </MenuItem>
        <MenuItem onClick={() => handleClick("/clientsaccounts")}>
          Klientkonton
        </MenuItem>
        <hr />
        <MenuItem onClick={() => handleClick("/endcustomersarticles")}>
          Slutkundsartiklar
        </MenuItem>
        <MenuItem onClick={() => handleClick("/endcustomersaccounts")}>
          Slutkundskonton
        </MenuItem>
        <hr />
        <MenuItem onClick={() => handleClick("/endcustomerunplaced")}>
          Oplacerat
        </MenuItem>
      </Menu>
    </div>
  );
}
